import { render, staticRenderFns } from "./StorageRequestDetail.vue?vue&type=template&id=0163b418&"
import script from "./StorageRequestDetail.vue?vue&type=script&lang=js&"
export * from "./StorageRequestDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports